module.exports = __webpack_public_path__ + "img/collection-weddingRingstrisets@2x.d0deec4.jpg";